import './style.scss';

import { FC } from 'react';
import { Modal as BootstrapModal } from 'react-bootstrap';

interface ModalProps {
    show: boolean;
    onHide?: () => void;
    className?: string;
    children: React.ReactNode;
}

const Modal : FC<ModalProps> = ({ show, onHide, className = '', children }) => (
    <BootstrapModal show={show} onHide={onHide} className={`modal ${className}`}>
        {children}
    </BootstrapModal>
);

export default Modal;
